"use client";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { debounce, escapeRegExp } from "lodash";

import { TextInput } from "@sendmagic/prismic-nextjs/src/components/utils/TextInput";

import defaultStyles from "./main.module.scss";

const defaultArr = [];

const SearchInput = ({
  data = defaultArr,
  attributes = defaultArr,
  onFilter,
  reset,
  focus,
  id,
  name,
  placeholder = "",
  styles = defaultStyles,
}) => {
  const [query, setQuery] = useState("");

  const inputRef = useRef();

  useEffect(() => {
    if (reset) {
      setQuery("");
    }
  }, [reset]);

  useEffect(() => {
    if (focus) {
      inputRef.current.focus();
    }
  }, [focus]);

  const filterData = useCallback(
    debounce(
      (val) => {
        const filteredData = data.filter((obj) => {
          const regexp = new RegExp(escapeRegExp(val.trim()), "i");
          return attributes.some((attr) => regexp.test(obj[attr]));
        });

        onFilter(filteredData);
      },
      300,
      {
        leading: false,
        trailing: true,
      }
    ),
    [onFilter]
  );

  const handleQueryChange = ({ value }) => {
    setQuery(value);
    filterData(value);
  };

  return (
    <TextInput
      id={id}
      name={name}
      value={query}
      onChange={handleQueryChange}
      classes={`${styles.formControlPadding} btm-drawer-fix-height`}
      placeholder={placeholder}
      autoComplete="off"
      ref={inputRef}
      styles={styles !== defaultStyles ? styles : undefined}
    />
  );
};

export default SearchInput;
